__turbopack_context__.v({
  "skeleton": "Skeleton-module-scss-module__47crGG__skeleton",
  "skeleton-animation": "Skeleton-module-scss-module__47crGG__skeleton-animation",
  "skeleton-line": "Skeleton-module-scss-module__47crGG__skeleton-line",
});
